<template>
  <div class="infoContainer">
    <!-- 医生所在医院名称 -->
    <div v-if="groupInfo?.hospitalFollowName" class="hospital z-flex-l">
      <div v-if="groupInfo?.hospitalFollowUrl">
        <a-avatar
          class="hospital-avatar"
          :size="24"
          :src="groupInfo?.hospitalFollowUrl"
          shape="square"
          alt="医院图片"
        />
      </div>
      <div class="hospital-name">
        <a-tooltip>
          <template #title>{{ groupInfo?.hospitalFollowName }}</template>
          {{ groupInfo?.hospitalFollowName }}
        </a-tooltip>
      </div>
    </div>
    <!-- 人员信息 -->
    <div class="roles">
      <a-collapse expandIconPosition="right" :bordered="false" v-model:activeKey="activeKeyInfo">
        <a-collapse-panel key="1">
          <template #header>
            <div class="roles-header">
              <div class="left">
                人员信息
                <span class="roles-sub-title" v-if="groupInfo?.doctorInfo">
                  <span v-if="groupInfo?.doctorInfo.accountStatus === 1">医生已停用</span>
                  <span v-if="groupInfo?.doctorInfo.accountStatus === 2">医生已注销</span>
                  <span v-if="groupInfo?.doctorInfo.accountStatus === 3">医生已停用 | 已注销</span>
                </span>
              </div>
            </div>
          </template>
          <div class="bodyPadding">
            <div class="roles-list z-flex" :class="{ floatLeft: solesList.length != 3 }">
              <div class="roles-item z-flex" v-for="item in solesList" :key="item.key">
                <solePopover
                  v-bind="$attrs"
                  :activeKey="item.key"
                  :data="item.val"
                  @healthInfo="healthInfo"
                  @talk="pChat"
                  :isPatChat="isPatChat"
                  :bindDocList="bindDocList"
                  :showMoreBindDoc="showMoreBindDoc"
                  :remarkData="item.key === 'patient' ? remarkData[0] : remarkData[1]"
                  :dealWorkOrderList="groupInfo.dealWorkOrderList"
                  @updateRemark="handleUpdateRemark"
                  @chatWithDoc="chatWithDoc"
                >
                  <template #content>
                    <div @click="handlePatientFile(item)" class="info-content z-flex">
                      <div class="img">
                        <auth-img :src="item.val.headUrl || item.cb" />
                        <auth-img
                          :src="handleImg(item.val.gender)"
                          class="gender"
                          v-if="[0, 1].includes(item.val.gender)"
                        />
                      </div>
                      <div class="info">
                        <div class="role-name">{{ handleUsername(item.val.username) }}</div>
                        <div
                          class="role-flag"
                          :class="doctorTeam && item.key === 'doctor' ? 'doctorTeam' : item.key"
                        >
                          {{
                            item.key === 'doctor'
                              ? item.val?.careerTypeDesc
                              : solesNameList[`${item.key}`]
                          }}
                        </div>
                      </div>
                    </div>
                  </template>
                </solePopover>
              </div>
            </div>
            <div v-if="remarkData[0]?.beRemarkContent">
              <RemarkPopover
                mode="patient"
                @updateRemark="handleUpdateRemark"
                :remarkData="remarkData[0]"
              >
                <template #content>
                  <div class="notes z-flex">
                    <span class="title">患者协同备注</span>
                    <a-tooltip placement="topLeft">
                      <template #title>
                        <span>{{ remarkData[0]?.beRemarkContent }}</span>
                      </template>
                      <span class="content">
                        {{ remarkData[0]?.beRemarkContent }}
                      </span>
                    </a-tooltip>
                  </div>
                </template>
              </RemarkPopover>
            </div>
            <div v-if="remarkData[1]?.beRemarkContent">
              <RemarkPopover
                mode="doctor"
                @updateRemark="handleUpdateRemark"
                :remarkData="remarkData[1]"
                :allowClear="true"
              >
                <template #content>
                  <div class="notes z-flex">
                    <span class="title">医生协同备注</span>
                    <a-tooltip placement="topLeft">
                      <template #title>
                        <span>{{ remarkData[1]?.beRemarkContent }}</span>
                      </template>
                      <span class="content doc">{{ remarkData[1]?.beRemarkContent }}</span>
                    </a-tooltip>
                  </div>
                </template>
              </RemarkPopover>
            </div>
            <!-- 服务标签 -->
            <div v-if="groupInfo.doctorPatientProjectLabelInfoList" class="ServiceTags">
              <span
                v-for="tag in groupInfo.doctorPatientProjectLabelInfoList"
                :key="tag.projectCode"
                class="ServiceTag"
              >
                {{ tag.projectName }}
              </span>
            </div>
          </div>
        </a-collapse-panel>
        <a-collapse-panel key="2" v-if="showPatientProfileList" class="associate">
          <template #header>
            <div class="header">
              <span class="title">关联就诊人</span>
            </div>
          </template>
          <patientProfileList
            :ucPatientId="ucPatientId"
            :ucDoctorId="ucDoctorId"
            :patientId="patientId"
            :doctorId="doctorId"
            @getRemark="getRemark"
            @getPatientProfileLists="getPatientProfileLists"
            ref="patientProfileListRef"
          />
        </a-collapse-panel>
        <!-- 合作协定方 -->
        <a-collapse-panel key="3" v-if="agreementBaseInfo?.prescriptionNumber > 0">
          <template #header>
            <div class="header">
              <span class="title">合作协定方</span>
            </div>
          </template>
          <div class="bodyPadding">
            <Agreement :ucDoctorId="ucDoctorId" :info="agreementBaseInfo"></Agreement>
          </div>
        </a-collapse-panel>
        <a-collapse-panel key="4" v-if="isHadFollowDays">
          <template #header>
            <div class="header z-flex">
              <span>下次复诊日期</span>
              <!--              <span class="seeFollowDays" @click.stop="goTreatSheet">查看复诊日期</span>-->
            </div>
          </template>
          <a-spin :spinning="loading">
            <div class="bodyPadding">
              <div>
                <span class="followLabel">复诊状态：</span>
                <span style="">
                  {{ Config.RESERCE_STATE_MAP[Number(followDaysDetail.reserveState)] || '无' }}
                </span>
              </div>
              <div style="margin-top: 6px">
                <span class="followLabel">就诊人：</span>
                <span style="">
                  {{ followDaysDetail.patientProfileCommonVO?.patientProfileName }}
                </span>
              </div>
              <div style="margin-top: 6px">
                <span class="followLabel">复诊日期：</span>
                <span style="color: #f78408">
                  {{ handleTimeShowWeek(followDaysDetail.reserveDate, 'YYYY-MM-DD') }}
                  {{ ['上午', '下午'][followDaysDetail.reserveDateDetail - 1] || '' }} ｜
                  {{ ['线上问诊', '门诊就诊'][followDaysDetail.revisitType - 1] || '' }}
                </span>
              </div>
              <div
                style="margin-top: 6px; justify-content: flex-start"
                class="z-flex"
                v-if="followDaysDetail.remark"
              >
                <div class="followLabel" style="min-width: 48px">备注：</div>
                <span style="color: #1c1c1c">
                  {{ followDaysDetail.remark }}
                </span>
              </div>
              <div class="btn-box">
                <div class="btn-item" @click.stop="openSupplementMRecord">
                  补充诊疗记录
                  <a-tooltip>
                    <template #title>
                      患者表示已复诊，协助患者补充诊疗记录，设置新的复诊日期，进入下一轮全病程跟进。
                    </template>
                    <img src="@/assets/img/query-icon.png" alt="" />
                  </a-tooltip>
                </div>
                <div class="btn-item" @click.stop="goTreatSheet">
                  修改复诊日期
                  <a-tooltip placement="topRight">
                    <template #title>
                      对未触达患者，或明确表示延后复诊的，修改复诊日期继续跟进。
                    </template>
                    <img src="@/assets/img/query-icon.png" alt="" />
                  </a-tooltip>
                </div>
              </div>
            </div>
          </a-spin>
        </a-collapse-panel>
        <a-collapse-panel key="5" :showArrow="false" disabled>
          <template #header>
            <div class="header" style="font-weight: 500">
              <div class="refresh-btn z-flex">
                <div class="title">当前会话工单</div>
                <div>
                  <span
                    class="opetrateBtns"
                    @click.stop="beforeHungup"
                    v-if="allSuspendStatus !== 2"
                  >
                    {{ allSuspendStatus ? '' : '取消' }}全部挂起
                  </span>
                  <span class="opetrateBtns" style="margin-left: 24px" @click="refreshOrderInfo">
                    刷新
                  </span>
                </div>
              </div>
            </div>
          </template>
          <div class="work-order-collapse">
            <a-collapse
              expandIconPosition="right"
              :bordered="false"
              v-model:activeKey="workActiveKey"
            >
              <a-collapse-panel key="1">
                <template #header>
                  <div class="header" style="font-weight: 500">
                    <span>我的工单</span>
                  </div>
                </template>
                <a-spin :spinning="loading">
                  <div class="workBodyPadding">
                    <RelationItem
                      :currentFlag="true"
                      v-for="item in groupInfo.dealWorkOrderList"
                      :key="item.workOrderId"
                      :info="item"
                      :doctorInfo="groupInfo.doctorInfo"
                      @openTransfer="openTransfer"
                      remarkIsEdit
                    />
                  </div>
                </a-spin>
              </a-collapse-panel>
              <a-collapse-panel key="2">
                <template #header>
                  <div class="header" style="font-weight: 500">
                    <span>其他工单</span>
                  </div>
                </template>
                <a-spin :spinning="loading">
                  <div
                    v-if="groupInfo.groupWorkOrderList && groupInfo.groupWorkOrderList.length"
                    class="workBodyPadding"
                  >
                    <RelationItem
                      :currentFlag="false"
                      v-for="item in groupInfo.groupWorkOrderList"
                      :key="item.workOrderId"
                      :info="item"
                      :doctorInfo="groupInfo.doctorInfo"
                    />
                  </div>
                  <div class="empty" v-else><img src="~@/assets/img/empty.png" /></div>
                </a-spin>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <!-- 转交 -->
    <transfer
      @onCancel="onCancelTransfer"
      v-model:visible="transferInfo.showTransfer"
      :groupId="groupInfo.groupId"
      :assistantPatientGroupId="groupInfo.assistantPatientGroupId"
      :doctorDaGroupId="groupInfo.doctorDaGroupId"
      :transferInfo="transferInfo"
    />
    <SetRetreatment
      ref="treatmentRef"
      isSheet
      @changeReverseDate="getFollowDays"
      :targetDate="moment(followDaysDetail.reserveDate)"
    />
    <MedicalRecordsPoup
      :visible="uploadRecordVisible"
      :params="{
        ucDoctorId: ucDoctorId,
        doctorId: doctorId,
        ucPatientId: ucPatientId,
        patientId: patientId
      }"
      :needAPI="true"
      :keepAlive="true"
      @savaData="savaData"
      @cancelClick="onClose"
      :communicateDoctor="false"
      :communicatePatient="false"
    ></MedicalRecordsPoup>
  </div>
</template>
<script setup>
import {
  defineProps,
  defineEmits,
  computed,
  ref,
  reactive,
  watch,
  watchEffect,
  defineExpose
} from 'vue'
import RelationItem from './components/relationItem.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import rf from '@/assets/img/chat/right-female.png'
import rm from '@/assets/img/chat/right-male.png'
import Transfer from '@/views/WorkPlace/components/Transfer/index.vue'
import solePopover from './solePopover/index.vue'
import head_p from '@/assets/img/chat/head_p.png'
import head_d from '@/assets/img/chat/head_d.png'
import head_a from '@/assets/img/chat/head_a.png' // BD的默认头像
import { talkToPat, getBindDocList, talkToDoctor, doctorTeamVest } from '@/api/chat'
import { getStateByWorkOrderId } from '@/api/workPlace/workOrder'
import { message } from 'ant-design-vue'
import useHungup from './hooks/useHungup'
import useRemark from '@/views/hooks/useRemark'
import RemarkPopover from '@/components/RemarkPopover'
import { REFRESH_MAIN, REFRESH_LIST } from '@/views/WorkPlace/handleEventBuss'
import { searchPatientFollowDays } from '@/api/workPlace/retreatment'
import { handleTimeShowWeek } from '@/utils'
import SetRetreatment from '@/views/WorkPlace/Container/chat/components/retreatment/setRetreatment.vue'
import patientProfileList from './components/patientProfileList.vue'
import Config from '@/config/index'
import Agreement from './components/Agreement/index.vue'
import useAgreementBaseInfo from '@/views/hooks/useAgreementBaseInfo'
import MedicalRecordsPoup from '@/views/HealthRecord/HealthInfo/common/medicalRecordsPoup.vue'
import moment from 'moment/moment'

const { agreementBaseInfo } = useAgreementBaseInfo()
const { getRemarkData } = useRemark()
const { handleHungup } = useHungup()
const router = useRouter()
const store = useStore()
const emit = defineEmits(['pChat', 'chatWithDoc'])
const workOrderGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const groupType = computed(() => workOrderGroupInfo?.value.groupType)
const allSuspendStatus = computed(() => {
  return getSuspendStatus()
})
defineProps({
  isPatChat: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
})
const activeKeyInfo = ref(['1', '2', '3', '4', '5'])
const workActiveKey = ref(['1', '2'])
const solesNameList = reactive({
  patient: '患者',
  doctor: '医生',
  assistant: '医生助手'
})
const groupInfo = ref({})
const ucPatientId = ref(null)
const patientId = ref(null)
const doctorId = ref(null)
const ucDoctorId = ref(null)
const solesList = ref([])
const doctorTeam = ref(false)
const patientProfileListRef = ref(null)
const showPatientProfileList = ref(true)

// 补充诊记录
const uploadRecordVisible = ref()
const openSupplementMRecord = () => {
  uploadRecordVisible.value = true
}

const onClose = () => {
  uploadRecordVisible.value = false
}
// 补充诊疗记录
const savaData = (type, data) => {
  uploadRecordVisible.value = false
  getFollowDays()
}

watchEffect(() => {
  groupInfo.value = workOrderGroupInfo?.value ?? {}
  ucPatientId.value = groupInfo.value?.patientInfo?.ucUserId ?? 0
  ucDoctorId.value = groupInfo.value?.doctorInfo?.ucUserId ?? 0
  patientId.value = groupInfo.value?.patientInfo?.businessId ?? 0
  doctorId.value = groupInfo.value?.doctorInfo?.businessId ?? 0
  const patientObj = {
    key: 'patient',
    cb: head_p, // 默认头像
    val: groupInfo.value.patientInfo
  }
  const doctorObj = {
    key: 'doctor',
    cb: head_d, // 默认头像
    val: groupInfo.value.doctorInfo
  }
  const assistantObj = {
    key: 'assistant',
    cb: head_a, // 默认头像
    val: groupInfo.value.bindAssistant
  }
  const isEffective = val => {
    const invalid = [null, undefined, '']
    if (invalid.includes(val)) return false
    const len = Object.keys(val || {}).length
    return !!len
  }
  // 给医生和患者添加标签属性
  const doctorPatientProjectLabelInfoList = groupInfo.value.doctorPatientProjectLabelInfoList
  const hasPatient = isEffective(patientObj.val)
  const hasDoctor = isEffective(doctorObj.val)
  // 必须有医生和患者才能添加标签属性
  if (hasPatient) {
    patientObj.val.doctorPatientProjectLabelInfoList = doctorPatientProjectLabelInfoList
  }
  if (hasDoctor) {
    doctorObj.val.doctorPatientProjectLabelInfoList = doctorPatientProjectLabelInfoList
  }
  switch (groupType.value) {
    case 3:
      solesList.value = [patientObj, doctorObj, assistantObj].filter(
        it => Object.keys(it?.val ?? {}).length
      )
      break
    case 4:
      solesList.value = [doctorObj, assistantObj].filter(it => Object.keys(it.val).length)
      break
    default:
      solesList.value = [patientObj, doctorObj, assistantObj].filter(
        it => Object.keys(it?.val ?? {}).length
      )
      break
  }
  queryBindDoctList()
  getRemark()
})

const refreshOrderInfo = () => {
  REFRESH_MAIN?.emit()
  store.dispatch('rollBack/getAllRefreshTimer')
}
const getPatientProfileLists = val => {
  showPatientProfileList.value = val?.length > 1
}
// 转交工单
const transferInfo = reactive({
  showTransfer: false,
  transferId: 0,
  ucDoctorId: '',
  ucPatientId: ''
})
function openTransfer(id) {
  getStateByWorkOrderId({ workOrderId: id }).then(res => {
    if (res === 200) {
      message.error('工单已完成，无法转交')
      REFRESH_LIST?.emit()
    } else {
      transferInfo.showTransfer = true
      transferInfo.transferId = id
      transferInfo.ucDoctorId = ucDoctorId.value
      transferInfo.ucPatientId = ucPatientId.value
    }
  })
}
// 遍历整个工单队列，是否全部都挂起了，0-不挂起；1-健管挂起；2-自动挂起"
function getSuspendStatus() {
  const dealWorkOrderList = workOrderGroupInfo?.value?.dealWorkOrderList || []
  if (dealWorkOrderList.find(item => item.suspendTag === 0)) {
    return 1
  } else if (dealWorkOrderList.find(item => item.suspendTag === 1)) {
    return 0
  } else {
    return 2
  }
}
// 挂起/取消全部挂起
const beforeHungup = () => {
  const dealWorkOrderList = workOrderGroupInfo?.value?.dealWorkOrderList || []
  const workOrderIds = dealWorkOrderList
    .filter(item => {
      if (allSuspendStatus.value === 1) {
        return item.suspendTag === 0
      } else {
        return item.suspendTag === 1
      }
    })
    .map(item => item.workOrderId)
  const params = {
    workOrderIds,
    suspendTag: allSuspendStatus.value,
    batchFlag: true,
    callBack: () => {
      REFRESH_MAIN?.emit()
      REFRESH_LIST?.emit()
      store.dispatch('rollBack/getAllRefreshTimer')
    }
  }
  handleHungup(params)
}
watch(
  [ucDoctorId, ucPatientId],
  () => {
    getFollowDays()
    getDoctorTeamVest()
  },
  { immediate: true }
)
// onMounted(() => {
//   getFollowDays()
//   getPatientProfile()
//   getDoctorTeamVest()
// })
async function getDoctorTeamVest() {
  try {
    const params = {
      ucDoctorId: ucDoctorId.value,
      ucPatientId: ucPatientId.value,
      groupId: groupInfo.value.groupId
    }
    const result = (await doctorTeamVest(params)) || {}
    const { doctorTeamName, hasVest } = result
    if (hasVest) {
      solesNameList.doctor = doctorTeamName
      doctorTeam.value = true
    }
  } catch (error) {
    console.log(error)
  }
}
function healthInfo() {
  router.push({
    path: '/healthInfo',
    query: {
      ucPatientId: ucPatientId.value,
      ucDoctorId: ucDoctorId.value
    }
  })
}
// 发起私聊
const pChat = async () => {
  const result = await talkToPat({
    ucPatientId: ucPatientId.value,
    ucDoctorId: ucDoctorId.value
  })
  emit('pChat', result)
}
// 发起医生私聊
const chatWithDoc = async () => {
  const result = await talkToDoctor({
    ucDoctorId: ucDoctorId.value
  })
  emit('chatWithDoc', result)
}
// 获取绑定医生列表
const bindDocList = ref([]) //绑定的医生列表
const showMoreBindDoc = ref(false)
function queryBindDoctList() {
  try {
    ucPatientId.value &&
      getBindDocList({ ucPatientId: ucPatientId.value }).then(res => {
        const { list = [] } = res
        showMoreBindDoc.value = list.length > 2
        bindDocList.value = list.splice(0, 2)
      })
  } catch {
    bindDocList.value = []
    showMoreBindDoc.value = false
  }
}
const remarkData = ref([])

function getRemark() {
  const params = {
    ucPatientId: ucPatientId.value,
    ucDoctorId: ucDoctorId.value || 0
  }
  getRemarkData(params).then(res => {
    remarkData.value = res.map((item, index) => {
      // index :0 查询患者协同备注，1 查询医生协同备注
      if (item.status === 'fulfilled') {
        const { beRemarkUcUserId } = item.value || {}
        const ucUserId = index === 0 ? ucPatientId.value : ucDoctorId.value
        if (beRemarkUcUserId + '' === ucUserId) {
          return item.value
        }
        return {}
      } else {
        return {}
      }
    })
  })
}

const isHadFollowDays = ref(false)
const followDaysDetail = ref({})
function getFollowDays() {
  searchPatientFollowDays({
    ucPatientId: ucPatientId.value,
    ucDoctorId: ucDoctorId.value
  }).then(res => {
    if (res) {
      isHadFollowDays.value = true
      followDaysDetail.value = res
    } else {
      isHadFollowDays.value = false
      followDaysDetail.value = {}
    }
  })
}

// 查看复诊日期表
const treatmentRef = ref(null)
function goTreatSheet() {
  treatmentRef.value.treatmentInit()
}

// 关闭转工单
const onCancelTransfer = () => {
  //
}
const handleUpdateRemark = () => {
  getRemark()
}
const handleImg = gender => {
  if (gender === 0) {
    return rf
  } else if (gender === 1) {
    return rm
  } else {
    return ''
  }
}
const handleUsername = name => {
  if (name && name.length > 3) {
    return name.substr(0, 5) + '...'
  } else {
    return name
  }
}
// 打开患者档案
const handlePatientFile = item => {
  if (item.key !== 'patient') return
  const { targetWorkOrder } = groupInfo.value
  const param = {
    patientId: patientId.value,
    doctorId: doctorId.value,
    patientType: 1,
    workOrderId: targetWorkOrder.workOrderId
  }
  store.dispatch('patientFile/openModal', param)
}

defineExpose({
  getRemark
})
</script>
<style scoped lang="scss">
.headerText {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
}
.work-order-collapse {
  // padding: 0 0 0 16px;
  .workBodyPadding {
    padding: 0 16px;
  }
  ::v-deep(
      .ant-collapse-borderless
        > .ant-collapse-item
        > .ant-collapse-content
        > .ant-collapse-content-box
    ) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  ::v-deep(.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header) {
    // padding: 5px 0px 14px 16px !important;
    padding-left: 16px !important;
    padding-right: 0px !important;
    border-top: 0px !important;
    @extend .headerText;
  }
}
.bodyPadding {
  padding: 0 16px;
}
.btn-box {
  cursor: pointer;
  margin-top: 12px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .btn-item {
    &:first-child {
      margin-right: 12px;
    }

    img {
      width: 14px;
      height: 14px;
    }
    width: auto;
    height: 30px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 4px;
    padding: 3px 12px;
    background: #ffffff;
    border: 1px solid #1890ff99;
    overflow: hidden;
    mix-blend-mode: normal;
    color: #1890ff;
  }
}
.infoContainer {
  background: #f7f8fa;
  ::v-deep(.ant-collapse-borderless) {
    background-color: #ffffff;
  }
  ::v-deep(.ant-collapse-borderless > .ant-collapse-item) {
    border-bottom: initial;
  }
  ::v-deep(.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header) {
    padding-left: 16px;
    padding-right: 16px;
    border-top: 1px solid #e8e8e8;
    @extend .headerText;
  }
  ::v-deep(
      .ant-collapse-borderless
        > .ant-collapse-item
        > .ant-collapse-content
        > .ant-collapse-content-box
    ) {
    // position: relative;
    padding-left: 0px;
    padding-right: 0px;
  }
  .hospital {
    padding: 10px 16px;
    background: #f3f6fa;
    align-items: flex-start;
    .hospital-avatar {
      margin-right: 6px;
    }
    .hospital-name {
      font-weight: bold;
      line-height: 24px;
      font-size: 14px;
      color: #495d87;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }
  }
  .roles {
    .roles-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - 12px - 16px);
      .roles-sub-title {
        font-weight: 400;
        font-size: 12px;
        color: #f5222d;
        margin-left: 20px;
      }
    }

    .associate {
      position: relative;
    }
    .associate-patient {
      // padding: 14px 16px;

      & > div:nth-child(2) {
        transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        overflow: hidden;
        max-height: 1000px;
      }
      .title {
        font-weight: 500;
        font-size: 14px;
        color: #303133;
        margin-bottom: 14px;
      }
      .content {
        padding: 13px;
        border-radius: 8px;
        border: 1px solid #e3e3e3;
        margin-bottom: 12px;
        .info {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 14px;
          color: #333;
          margin-bottom: 13px;
          .name {
            max-width: 45%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          span {
            margin-right: 10px;
          }
          .patient {
            padding: 3px 6px;
            font-weight: 400;
            font-size: 10px;
            color: #ffa940;
            border-radius: 4px;
            background: #ffeed9;
            line-height: 10px;
          }
          .relation {
            border: 1px solid #c7d1dbb3;
            padding: 2px 5px;
            font-weight: 400;
            font-size: 10px;
            color: #8088a5;
            border-radius: 4px;
            background: #ffffff;
            line-height: 10px;
          }
        }
        .remark-box {
          padding: 7px 12px 2px 12px;
          border-radius: 4px;
          background-color: rgba(216, 216, 216, 0.2);
          font-weight: 400;
          font-size: 12px;
          color: #f78408;
          line-height: 16px;
          .remark {
            display: flex;
            margin-bottom: 5px;
            .type {
              font-weight: 400;
              font-size: 12px;
              color: #666;
              margin-right: 14px;
              width: 25%;
            }
          }
        }
      }
      .select {
        position: relative;
        border: 1px solid #1890ffcc;
        .current {
          position: absolute;
          right: -1px;
          top: -1px;
          padding: 3px 8px;
          font-weight: 400;
          font-size: 12px;
          color: #fff;
          border-radius: 0 8px 0 8px;
          background: #1890ff;
          border-radius: 0 8px 0 8px;
        }
      }
      .fold {
        max-height: 215px !important;
      }
      .fold-text {
        position: absolute;
        bottom: 0px;
        width: 100%;
        background: #fff;
        padding: 5px 0;
        cursor: pointer;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #666;
        .expand {
          width: 16px;
          height: 16px;
        }
      }
      .ellipsis-text {
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .edit {
        cursor: pointer;
        color: #1890ff;
        font-size: 12px;
        font-weight: 400;
      }
    }

    .refresh-btn {
      // padding: 12px 16px;
      // border-top: 1px solid #e8e8e8;
      @extend .headerText;

      .opetrateBtns {
        font-weight: 400;
        font-size: 12px;
        color: #014ea8;
        letter-spacing: 0;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .roles-list {
      &.floatLeft {
        justify-content: flex-start;
      }
      .roles-item {
        font-weight: 500;
        font-size: 14px;
        color: #666666;

        width: 33.3%;
        .info-content {
          align-items: center;
          cursor: pointer;
          .img {
            width: 36px;
            height: 36px;
            border-radius: 4px;
            overflow: hidden;
            margin-right: 4px;
            position: relative;
            .gender {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 11px;
              height: 10px;
            }
            img {
              width: 100%;
            }
          }
          .info {
            flex-direction: column;
            .role-name {
              line-height: 1;
              font-size: 14px;
              color: #666;
            }
            .role-flag {
              margin-top: 5px;
              padding: 1px 6px;
              font-size: 10px;
              color: #ffa940;
              background: #ffeed9;
              border-radius: 4px;
              text-align: center;
              width: fit-content;
              &.doctor {
                background: #d6eaff;
                color: #1890ff;
              }
              &.doctorTeam {
                background-image: linear-gradient(270deg, #fff4ec 0%, #ffe5ce 99%);
                color: #a66837;
              }
              &.assistant {
                background: #d3f2ec;
                color: #24bca2;
              }
            }
          }
        }
      }
    }
    .ServiceTags {
      display: flex;
      flex-wrap: wrap;
      margin-top: 12px;
      .ServiceTag {
        font-weight: 500;
        color: #b97642;
        font-size: 10px;
        border: 1px solid #d0a279;
        border-radius: 4px;
        padding: 2px 6px;
        height: 20.1px;
        line-height: 14px;
        margin: 0 8px 2px 0;
      }
    }
    .notes {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      margin-top: 12px;
      cursor: pointer;
      .title {
        width: 86px;
      }
      .content {
        color: #f78408;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        word-break: break-all;
        &.doc {
          color: #f40c0c;
        }
      }
    }
    .border {
      border-top: 1px solid #e8e8e8;
    }
    .header {
      @extend .headerText;
      align-items: center;
      .seeFollowDays {
        font-weight: 400;
        font-size: 12px;
        color: #014ea8;
        letter-spacing: 0;
        text-align: right;
        line-height: 20px;
        margin-right: 34px;
      }
    }
    .followLabel {
      color: #666;
    }
  }
  .empty {
    text-align: center;
    img {
      width: 128px;
      height: 128px;
    }
  }
}
</style>
